import styled from '@emotion/styled';

// Used to skip to the main content of the page when the user presses the tab key.
// Accessibility feature.
export const SkipLink = styled.a<{ focusColor: string }>`
  position: absolute;
  top: -40px;
  left: 0;
  background: #141414;
  color: #ffffff;
  padding: 8px 16px;
  text-decoration: none;
  z-index: 1000;
  border: 1px solid #424242;
  border-radius: 4px;

  /* Visually hidden by default */
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  width: 1px;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;

  /* Show when focused */
  &:focus {
    clip: auto;
    clip-path: none;
    width: auto;
    height: auto;
    margin: 0;
    top: 8px;
    left: 8px;
    position: fixed;
  }

  &:focus-visible {
    outline: 2px solid ${({ focusColor }) => focusColor};
    outline-offset: 2px;
  }
`;
